export enum THRIVE_ACTIVITY_TYPE {
  BREATHE = 'breathe',
  MEDITATE = 'meditate',
  SLEEP = 'sleep',
  YOGA = 'yoga',
}
